__webpack_require__.p = "https://assets.canny.io/7157e8fadde6adf8c1de8523a89b44b275cf1333/";